// extracted by mini-css-extract-plugin
export default {"timeDisplay":"Time_timeDisplay__-QDPZ","date":"Time_date__hZbzV","time":"Time_time__fIdHi"};